export const I18N_NAMESPACES = [
  'common',
  'navigation',
  'auth',
  'register',
  'dashboard',
  'customers',
  'customerInvitations',
  'tenants',
  'support',
  'billing',
  'pricing',
  'stripe',
  'notifications',
  'providers',
  'storage',
  'dataLifecycle',
  'features',
  'tenantAccess',
  'setupWizard',
  'tenantProvisioning',
  'tenantSchema',
  'tenantSchemaRunner',
  'onboarding',
  'statuses',
  'status',
  'validation',
  'settings',
  'mafertappModules',
  'subscriptionChanges',
  'moduleAccessEvents',
  'permissionCleanup',
  'permissions',
  'setupProfiles',
  'launchReadiness',
  'customerPortal',
  'systemLabels',
];
